import { useEffect } from 'react'
import { useBlazeImageGeneration } from './useBlazeImageGeneration'
import { SelectedImage } from 'types'
import Styles from '../BlazeRecommendationsRow/BlazeRecommendationsRow.module.scss'

interface GeneratingRecommendationProps {
  id: string
  brandProfileId: number
  onSuccess: (id: string, image: SelectedImage) => void
  onError: (id: string) => void
  variant?: 'row' | 'grid'
}

export const GeneratingRecommendation = ({
  id,
  brandProfileId,
  onSuccess,
  onError,
  variant = 'row',
}: GeneratingRecommendationProps) => {
  const { image, error } = useBlazeImageGeneration({ brandProfileId })

  useEffect(() => {
    if (image) onSuccess(id, image)
    if (error) onError(id)
  }, [image, error, id, onSuccess, onError])

  return (
    <div className={variant === 'grid' ? Styles.generatingPlaceholderGrid : Styles.generatingPlaceholder}>
      <div className={Styles.loadingShimmer} />
    </div>
  )
}
